module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "grey darken-3 elevation-5",
    attrs: {
      "dark": "",
      "dense": ""
    }
  }, [(_vm.$route.path !== '/AboutMe') ? _c('v-toolbar-side-icon', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleSidebar()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar-title', [_c('b', [_vm._v(" Portfolio ")]), _vm._v(" | "), _c('span', {
    staticClass: "caption ml-2"
  }, [_vm._v(" Sanyanee T.「サンヤニー」")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": "/",
      "icon": "",
      "light": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hiddenSider()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../img/icon/mascot.svg"),
      "width": "35px"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ae5ab77"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toolbar.vue
// module id = 61
// module chunks = 8